import { render } from "./MediathequePosteVideoPage.vue?vue&type=template&id=731e2778"
import script from "./MediathequePosteVideoPage.vue?vue&type=script&lang=js"
export * from "./MediathequePosteVideoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__